<template>
  <div>
    <div v-if="!isEmpty" class="card-main">
      <el-row>
        <el-col :span="6" v-for="item in data" :key="item.templateCode">
          <el-card :body-style="{ padding: '0px' }" class="m-3">
            <div class="text-center">
              <el-image
                fit="fit"
                class="template-image"
                :src="
                  item.templateThumbnailUrl
                    ? $osscdn(item.templateThumbnailUrl)
                    : '/image/static/img/nopic.jpg'
                "
                :preview-src-list="[
                  item.templateThumbnailUrl
                    ? $osscdn(item.templateThumbnailUrl)
                    : '/image/static/img/nopic.jpg',
                ]"
              >
                <div slot="error" class="image-slot">
                  <img
                    src="/image/static/img/nopic.jpg"
                    style="width: 100%; height: 150px"
                  />
                </div>
              </el-image>
            </div>
            <div class="card-content">
              <span class="card-content-header mt-2">
                <TemplateText :content="item.templateName" />
              </span>
              <div class="card-content-body">
                <el-button
                  type="text"
                  class="p-0 mt-1"
                  @click="$emit('confirm', item)"
                >
                  {{ $l('INDEX.dialog_choose_system_template') || '选择模板' }}
                </el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div v-if="isEmpty">
      <div class="empty-content">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateText from './template-text'
export default {
  components: { TemplateText },
  props: {
    data: { type: Array, default: () => [] },
  },
  computed: {
    isEmpty() {
      return !this.data || !this.data.length
    },
  },
}
</script>
<style lang="scss" scoped>
.empty-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
}
.card-main {
  max-height: 530px;
  overflow: auto;
  .template-image {
    height: 150px;
  }
  .card-content {
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    .card-content-header {
      font-size: 14px;
    }
    .card-content-body {
      .text {
        line-height: 16px;
        font-size: 13px;
        color: #999;
        height: 16px;
      }
    }
  }
}
.template-text-conent {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
